import { render, staticRenderFns } from "./ui-button-stack.vue?vue&type=template&id=09bc4859&"
import script from "./ui-button-stack.vue?vue&type=script&lang=js&"
export * from "./ui-button-stack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports